import { gql } from '@apollo/client'

export const EMPLOYEE_INFO = gql`
    query employeeInfo {
        employeeInfo {
            name
            nickname
            socialName
            branchName
            gender
            birthday
            profilePicture
            eSocialCategory
            individualRegistration
            email
            address
            numberAddress
            neighborhood
            city
            state
            zipCode
            educationLevel
            registration
            occupation {
                description
            }
            position {
                description
            }
            costCenter {
                description
            }
            department {
                description
            }
        }
    }
`
